import { CSSProperties } from 'react';
import { LoadIndicatorCenteredView } from '@vivli/shared/views';

const loadingDivStyle: CSSProperties = {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    zIndex: 1,
};

export const LoadingOverlayView = () => {
    return (
        <div style={loadingDivStyle}>
            <LoadIndicatorCenteredView />
        </div>
    );
};
